import { createHead } from '@unhead/vue/client'
import { createApp } from 'vue'

import App from './App.vue'
import { i18n } from './plugins/i18n'
import { createPinia } from 'pinia'
import { useLocaleStore } from './stores/locale.store'
import { useDevFormStore } from '@/stores/dev-form.store'
import { useTracking } from '@/composables/useTracking'
import { startDeferredClientModules } from '@/bootstrap/deferredClientModules'
import { applyStoredScreeningColorProfile } from '@/theme/colorProfiles'
import { env } from '@/utils/env'
import { installTrustedJsonLdHeadPlugin } from '@/utils/trustedJsonLdScript'

import { router } from './router'

import '../assets/css/fonts.css'
import '../assets/css/style.css'

applyStoredScreeningColorProfile()

const app = createApp(App)
const head = createHead()
installTrustedJsonLdHeadPlugin(head)
const pinia = createPinia()

app.use(head)
app.use(i18n)
app.use(pinia)
app.use(router)

if (typeof window !== 'undefined') {
  const localeStore = useLocaleStore()
  localeStore.initLocale()
}

if (env.isDev) {
  const devFormStore = useDevFormStore()
  devFormStore.init()
}

app.mount('#app')

if (typeof window !== 'undefined') {
  useTracking(router)
  startDeferredClientModules(app)
}
